<template>
  <div :class="keyboardClass"></div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard",
      type: String
    },
    input: {
      type: String
    },
    layout: {
      type: Object,
      default: ()=> {
        return {
        default: ["1 2 3", "4 5 6", "7 8 9", ".00 0 .", "{bksp}"],
      }
      }
    }
  },
  data: () => ({
    keyboard: null
  }),
  mounted() {
    this.keyboard = new Keyboard({
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      layout: this.layout,
      theme: "hg-theme-default hg-layout-numeric numeric-theme"
        })

    this.$nextTick(()=>{
      if(this.$vuetify.theme.dark){
        this.keyboard.setOptions({theme: "hg-theme-default hg-layout-numeric numeric-theme darkKeyboard"})
      }else{
        this.keyboard.setOptions({theme: "hg-theme-default hg-layout-numeric numeric-theme"})
      
      }
      this.$watch( ()=> this.$vuetify.theme.dark ,(val)=>{
      if(val){
        this.keyboard.setOptions({theme: "hg-theme-default hg-layout-numeric numeric-theme darkKeyboard"})
      }else{
        this.keyboard.setOptions({theme: "hg-theme-default"})
      }
    })
    })
  },
  methods: {
    onChange(input) {
      this.$emit("onChange", input);
    },
    onKeyPress(button) {
      this.$emit("onKeyPress", button);

      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shift}" || button === "{lock}") this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    }
  },
  watch: {
    input(input) {
      this.keyboard.setInput(input);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hg-theme-default {
  font-weight:800;
  font-size:2.1rem;
  color:#000;
  font-family: Roboto,sans-serif!important
}
</style>